<!--
  @file Componente PanelComponent.vue
  @description Componente para crear paneles dentro de componentes y/o vistas

  @author Adrian Zayas <adrianzayas@unindetec.edu.mx>
  @date 06-03-2025
  @version 1.0.1
  @descriotionUpdate: Se agrega la propiedad visible para controlar la visibilidad del panel desde el componente padre,
  asi mismo se da prioridad baja a este componente sobre los demas componentes de la vista padre y finalmente se agrega
  un scroll al sidebar para poder ver todo el contenido del panel.
-->

<template>
    <b-sidebar :id="id" v-model="isVisible" @hidden="emitClose" right shadow sidebar-class="panel-sidebar">
      <template #header="{ hide }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="closePanel($event, hide)" size="sm" class="btnPanel">
            <feather class="iconPanel" type="arrow-right-circle" ></feather>
          </b-button>
        </div>
      </template>
      <div class="panel">
        <slot></slot>
      </div>
    </b-sidebar>
</template>

<script>
export default {
  props: {
    id:{ type: String, required: false, default: ''},
    visible:{ type: Boolean, required: false, default: false},
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    }
  },
  methods: {
    closePanel(event, hide) {
      event.currentTarget.blur();
      hide();
    },
    emitClose() {
      this.$emit("update:visible", false);
    }
  }
}
</script>

<style>
.b-sidebar-outer{
  z-index: 2;
}
.b-sidebar.panel-sidebar {
  width: min(385px, 100vw);
  top: 70px !important;
  background-color: white !important;
  height: calc(100vh - 70px) !important;
  height: calc(100dvh - 70px) !important;
  overflow-y: auto !important;
}

/* Topbar más alta en pantallas muy grandes (ver VerticalHeader.vue) */
@media (min-width: 3150px) {
  .b-sidebar.panel-sidebar {
    top: 100px !important;
    height: calc(100vh - 100px) !important;
    height: calc(100dvh - 100px) !important;
  }
}

.iconPanel {
  color: #036194;
  height: 1.8rem;
  opacity: 1;
}
.btnPanel,
.btnPanel:hover,
.btnPanel:active {
  background-color: white !important;
  border: none !important;
}

.panel{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
}

@media (max-width: 575.98px) {
  .panel {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

</style>
